// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__pqmMt","title":"BackImages_title__2jTi2","images":"BackImages_images__3L8gO"};